import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {ActionsRow, ScrollableCard, utils, Loader, PageContent} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {CardBody, Col, Nav, Row} from "reactstrap";
import MenuItem from "../../components/MenuItem";
import MenuPanel from "../../components/MenuPanel";
import * as opravneniActions from "../../actions/opravneniActions";
import {getAdminMenuItems} from "../../const/AdminMenuItems";
import Title from "../../components/Title";
import {withTranslation, WithTranslation} from "react-i18next";
import './AdminPage.scss';

/**
 * Stránka administrace, zobrazující menu po levé straně a obsah konkrétní stránky vpravo.
 */
class AdminPage extends Component<WithTranslation> {

    static propTypes = {
        title: PropTypes.string.isRequired, // název stránky
        subtitle: PropTypes.string, // podnadpis stránky
        tabs: PropTypes.oneOfType([PropTypes.array, PropTypes.node]), // záložky v záhlaví, pokud není uvedeno nebudou zobrazeny
        content: PropTypes.node.isRequired, // obsah stránky (pod záhlavím)
        noScroll: PropTypes.bool, // zda neobalovat content do scrollable card, implicitně false
    };

    static defaultProps = {
        noScroll: false,
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
    };

    renderHeader = () => {
        const {title, subtitle, tabs} = this.props;

        return <div className="page-content-header">
            <CardBody>
                <ActionsRow className="my-2">
                    <h2>{subtitle}</h2>
                    <h1 className="mb-0">{title}</h1>
                </ActionsRow>
            </CardBody>
            {tabs && this.renderTabs(tabs)}
        </div>;
    };

    renderTabs = (tabs) => {
        return <Nav tabs className="bg-primary-lighten nav-tabs-detail">
            {tabs}
        </Nav>
    };

    render() {
        const {loggedInUser, content, title, noScroll, t} = this.props;

        if (!loggedInUser.fetched || loggedInUser.isFetching) {
            return <Loader/>;
        }

        return <Title title={`Administrace - ${title}`}>
            <Row noGutters className="w-100">
                <Col xs={3} className="h-100">
                    <MenuPanel children={getAdminMenuItems(loggedInUser.data, t).map(menuItem =>
                        <MenuItem key={menuItem.key} title={menuItem.title} route={menuItem.path} subItem={menuItem.subItem}/>
                    )}/>
                </Col>
                <Col xs={9} className="h-100">
                    <PageContent fullWidth header={this.renderHeader()} className="admin-page-content">
                        {noScroll ? content :
                        <ScrollableCard detail>
                            {content}
                        </ScrollableCard>}
                    </PageContent>
                </Col>
            </Row>
        </Title>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(AdminPage));

